// extracted by mini-css-extract-plugin
export default {"sectionname":"AddAppWizard_sectionname__uY4zI"};